'use strict';

import { Entity } from '../Entity';

export class IndPlanYearReview extends Entity {
  protected id;

  protected ind;

  protected planYear;

  protected dateTimeCreated;

  protected planYearInView;

  constructor() {
    super();
  }

  public hydrate(data: any) {
    this.id = data.id;

    this.ind = data.ind;

    this.planYear = data.planYear;

    this.dateTimeCreated = data.dateTimeCreated;

    this.planYearInView = data.planYearInView;
  }

  public getId() {
    return this.id;
  }

  public setId(id) {
    this.id = id;

    return this;
  }

  public getInd() {
    return this.ind;
  }

  public setInd(ind) {
    this.ind = ind;

    return this;
  }

  public getPlanYear() {
    return this.planYear;
  }

  public setPlanYear(planYear) {
    this.planYear = planYear;

    return this;
  }

  public getDateTimeCreated() {
    return this.dateTimeCreated;
  }

  public setDateTimeCreated(dateTimeCreated) {
    this.dateTimeCreated = dateTimeCreated;

    return this;
  }

  public getPlanYearInView() {
    return this.planYearInView;
  }
}
